export const IRS_GATEWAY_ENDPOINT = (window).irsAdminSettings
    .irsAdminEndPoint;
export const IRS_GATEWAY_REPORT_ENDPOINT = (window).irsAdminSettings
.irsAdminReportEndPoint;
export const IRS_GATEWAY_WALLET_ENDPOINT = (window).irsAdminSettings
.irsAdminWalletEndPoint;
export const ACCESS_TOKEN_KEYWORD = (window).irsAdminSettings
    .accessTokenKeyword;
export const MAX_MONTH_RANGE = (window).irsAdminSettings.maxTransactionMonthRange;
export const MAX_MOBILE_NUMBER_LENGHT = (window).irsAdminSettings.maxMobileNumberLenght;

export const CHANNEL_OPTION = [{
        value: "TH001",
        label: "TH001 (Branch)",
    },
    {
        value: "TH004",
        label: "TH004 (Wallet)",
    },
];

export const STATUS_OPTION = [{
        value: "2",
        label: "Success",
    },
    {
        value: "3",
        label: "Failed",
    },
];

export const TRANS_STATUS_OPTION = [{
        value: "C",
        label: "TRANSACTION CREATED",
    },
    {
        value: "U",
        label: "TRANSACTION UPDATED",
    },
    {
        value: "FR",
        label: "FAIL REMITTANCE",
    },
    {
        value: "SRP",
        label: "SUCCESS REMITTANCE PRECONFIRM",
    },
    {
        value: "SR",
        label: "SUCCESS REMITTANCE",
    },
    {
        value: "SN",
        label: "SUCCESS NOTIFICATION",
    },
    {
        value: "SC",
        label: "SUCCESS CANCEL",
    },
    {
        value: "FC",
        label: "FAIL CANCEL",
    },
];

export const SEARCH_BY_OPTION = [{
        value: "sender_name",
        label: "Sender Name",
    },
    {
        value: "sender_id",
        label: "Sender ID",
    },
    {
        value: "sender_mobile",
        label: "Sender Mobile",
    },
    {
        value: "receiver_name",
        label: "Receiver Name",
    },
    {
        value: "receiver_id",
        label: "Receiver ID",
    },
    {
        value: "receiver_mobile",
        label: "Receiver Mobile",
    },
    {
        value: "irs_transaction_id",
        label: "IRS Transaction ID",
    },
    {
        value: "irs_wallet_transaction_id",
        label: "IRS Wallet Transaction ID",
    },
    {
        value: "utiba_trans_id",
        label: "Utiba Trans ID",
    },
    {
        value: "utiba_cancel_trans_id",
        label: "Utiba Cancel Trans ID",
    },
    {
        value: "merchant_order_id",
        label: "Merchant Order ID",
    },
    {
        value: "merchant_payment_id",
        label: "Merchant Payment ID",
    },
    {
        value: "merchant_refund_id",
        label: "Merchant Refund ID",
    }
];

export const COUNTRY_OPTION = [{
        value: "855",
        label: "Cambodia",
    },
    {
        value: "95",
        label: "Myanmar",
    },
];

export const ACTIVITY_OPTION = [{
        value: "VERIFY IRS",
        label: "Verify IRS",
    }, {
        value: "TRANSFER MONEY",
        label: "Transfer Money",
    }, {
        value: "RESEND SMS PASSCODE",
        label: "Resend SMS Passcode",
    }, {
        value: "CASH OUT PRECONFIRM",
        label: "Cash Out Preconfirm",
    }, {
        value: "CASH OUT",
        label: "Cash Out",
    },
    {
        value: "CANCEL",
        label: "Cancel",
    },
    {
        value: "SUBMIT REMITTANCE",
        label: "Submit Remittance",
    }
];

export const KEYCLOAK_ROLES = {
    "API_BOT_DOWNLOAD": "API_BOT_DOWNLOAD",
    "API_CANCEL_TRANSACTION": "API_CANCEL_TRANSACTION",
    "API_EDIT_TIER": "API_EDIT_TIER",
    "API_EXPORT_IRS_TRANSACTION": "API_EXPORT_IRS_TRANSACTION",
    "API_REMOVE_KYC_UPLOAD": "API_REMOVE_KYC_UPLOAD",
    "API_REPRINT_SLIP": "API_REPRINT_SLIP",
    "API_RESEND_SMS": "API_RESEND_SMS",
    "API_SUBMIT_RATE": "API_SUBMIT_RATE",
    "API_SUBMIT_BANK_COST_RATE": "API_SUBMIT_BANK_COST_RATE",
    "API_VIEW_PASSPORT": "API_VIEW_PASSPORT",
    "API_VIEW_WORKPERMIT": "API_VIEW_WORKPERMIT",
    "VIEW_BOT_DOWNLOAD_RPT": "VIEW_BOT_DOWNLOAD_RPT",
    "VIEW_BOT_UPLOAD_RPT": "VIEW_BOT_UPLOAD_RPT",
    "VIEW_EXCHANGE_RATE_CONF": "VIEW_EXCHANGE_RATE_CONF",
    "VIEW_BANK_COST_RATE_CONF": "VIEW_BANK_COST_RATE_CONF",
    "VIEW_IRS_TRANSACTION_RPT": "VIEW_IRS_TRANSACTION_RPT",
    "VIEW_KYC_SUMMARY_RPT": "VIEW_KYC_SUMMARY_RPT",
    "VIEW_KYC_UPLOAD_RPT": "VIEW_KYC_UPLOAD_RPT",
    "VIEW_TIER_HISTORY_RPT": "VIEW_TIER_HISTORY_RPT",
    "VIEW_TIER_PRICING_CONF": "VIEW_TIER_PRICING_CONF",
    "VIEW_IRS_CAMBODIA_TRANSACTION_RPT": "VIEW_IRS_CAMBODIA_TRANSACTION_RPT",
    "VIEW_IRS_MYANMAR_TRANSACTION_RPT": "VIEW_IRS_MYANMAR_TRANSACTION_RPT"
};

export const COUNTRY = [{
        code: "95",
        name: "Myanmar",
        currency: "MMK",
    },
    {
        code: "855",
        name: "Cambodia",
        currency: "KHR",
    },
];

export const EXCHANGE_RATE_TYPE = {
    GENERIC: "Generic",
    NEW_CUSTOMER: "New Customer",
    SPECIAL_TRANSACTION: "Special Transaction",
    SPECIAL_CUSTOMER: "Special Customer",
}

/**
 * An array of headers for the special customer CSV file.
 * 
 * @constant {string[]}
 */
export const SPECIAL_CUSTOMER_CSV_HEADERS = [
    "MARK_DELETE",
    "MOBILE_NO",
    "KH_SPECIAL_CUSTOMER_RATE",
    "MM_SPECIAL_CUSTOMER_RATE"
]

/**
 * This regular expression matches error messages in the format [IRS_REPORT:4001]
 * @type {RegExp}
 */
export const ERROR_PREFIX_REGEX = /\[[A-Z_]+:\d+\]/g;

export const BASE_10 = 10;
